import Api from '../Api'

const editUserForm = {
  namespaced: true,
  state: {
    opened: false,
    user: null,
    subscriptions: [],
    submitting: false
  },
  mutations: {
    open(state, user) {
      state.opened = true
      state.user = { ...user }
    },
    close(state) {
      state.opened = false
      state.subscriptions = []
    },
    saved(state) {
      state.opened = false
    },
    notSaved(state) {
      state.opened = true
    },
    submitting(state) {
      state.submitting = true
    },
    submitted(state) {
      state.submitting = false
    }
  },
  actions: {
    async updateUser({ commit, state }, params) {
      commit('submitting')
      await Api.put(`/guestroom/users/${params.id}`, params)
      .then(({ data: { user }}) => {
        commit('saved')
        commit('users/replace', user, { root: true })
        commit('notification/show', { type: "success", message: "Hurrah!", description: "User successfully updated." }, { root: true })
        commit('submitted')
      })
      .catch((error) => {
        var description = 'Sorry, the user was not updated. Please try again.'
        if(error.response.data.error) description = error.response.data.error
        commit('notSaved')
        commit('notification/show', { type: "error", message: "Wuh-oh!", description: description }, { root: true })
        commit('submitted')
      });
    },
  }
}

export default editUserForm